import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import { useState, useEffect } from "react";
import { DosenSidangService } from "../../../../services/Integration/dosen-sidang/DosenSidangService";
import DashboardDosenTable from "./DashboardDosenTable";
import { STATUS_TINDAKAN } from "../../../../utils/constants/StatusTindakan.constants";
import DOSEN_ROLES from "../../../../utils/constants/DosenRoles.constants";

export default function SidangDosenChild({ dosenRole, term }) {
  const [tabValue, setTabValue] = useState(currentTab());
  const [stat, setStat] = useState({
    butuh_tindakan: "-",
    menunggu_pihak_lain: "-",
    selesai: "-",
    semua: "-",
  });

  useEffect(() => {
    getStatMKSpesialByDosenRole();
  }, [tabValue, term]);

  function currentTab() {
    const path = window.location.hash;
    if (path.includes("butuh-tindakan")) return "1";
    else if (path.includes("menunggu-pihak-lain")) return "2";
    else if (path.includes("selesai")) return "3";
    return "4"; //semua
  }

  const getStatMKSpesialByDosenRole = async () => {
    if (dosenRole === DOSEN_ROLES.pembimbing) {
      await DosenSidangService.getStatMKSpesialBimbingan(term)
        .then((response) => {
          if (response && response.status === 200) {
            setStat(response.data);
          } else {
            console.log("stat", response);
          }
        })
        .catch((error) => console.log(error));
    } else if (dosenRole === DOSEN_ROLES.penguji) {
      await DosenSidangService.getStatMKSpesialYangDiuji(term)
        .then((response) => {
          if (response && response.status === 200) {
            setStat(response.data);
          } else {
            console.log("stat", response);
          }
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <div className="my-4">
      <TabContext value={tabValue}>
        <TabList onChange={(e, value) => setTabValue(value)} centered>
          <Tab
            href={`#${dosenRole}-semua`}
            label={<span className="px-4">Semua ({stat.semua})</span>}
            value={"4"}
          />
          <Tab
            href={`#${dosenRole}-butuh-tindakan`}
            label={
              <span className="px-4">
                Butuh Tindakan ({stat.butuh_tindakan})
              </span>
            }
            value={"1"}
          />
          <Tab
            href={`#${dosenRole}-menunggu-pihak-lain`}
            label={
              <span className="px-4">
                Menunggu Tindakan Pihak Lain ({stat.menunggu_pihak_lain})
              </span>
            }
            value={"2"}
          />
          <Tab
            href={`#${dosenRole}-selesai`}
            label={<span className="px-4">Selesai ({stat.selesai})</span>}
            value={"3"}
          />
        </TabList>
        <TabPanel value={"4"} sx={{ padding: 0 }}>
          <DashboardDosenTable
            term={term}
            dosenRole={dosenRole}
            statusTindakan={STATUS_TINDAKAN.semua}
          />
        </TabPanel>
        <TabPanel value={"1"} sx={{ padding: 0 }}>
          <DashboardDosenTable
            term={term}
            dosenRole={dosenRole}
            statusTindakan={STATUS_TINDAKAN.butuh_tindakan}
          />
        </TabPanel>
        <TabPanel value={"2"} sx={{ padding: 0 }}>
          <DashboardDosenTable
            term={term}
            dosenRole={dosenRole}
            statusTindakan={STATUS_TINDAKAN.menunggu_pihak_lain}
          />
        </TabPanel>
        <TabPanel value={"3"} sx={{ padding: 0 }}>
          <DashboardDosenTable
            term={term}
            dosenRole={dosenRole}
            statusTindakan={STATUS_TINDAKAN.selesai}
          />
        </TabPanel>
      </TabContext>
    </div>
  );
}
